import React from 'react';
import InfoModal from './InfoModal';

function Info() {
  const currentQueryString =
    typeof window !== 'undefined' ? window.location.search : '';
  const [open, setOpen] = React.useState(
    currentQueryString.includes('redirect=') ? true : false,
  );
  function handleClose() {
    setOpen(false);
  }
  return (
    <InfoModal open={open} onClose={handleClose} source={currentQueryString} />
  );
}

export default Info;
